<div style="position:sticky; top:-1px; z-index:100;">
  <app-dp-bottom-sheet-closer (closeClicked)="closesheet()" >
  </app-dp-bottom-sheet-closer>
</div>

<div class="edit-details-container  ">
  <div class="d-flex flex-column justify-content-center align-items-center gap-4">
    <div class="d-flex justify-content-between" style="width:100%">
      <span class="edit-details-text">Edit details</span>
    </div>
  </div>

  <form (ngSubmit)="editDetails()" [formGroup]="editDetailsForm" class="d-flex flex-column gap-4">
    <div class="d-flex flex-column">
      <label class="search-text">Serial no.</label>
      <div class="d-flex align-items-center position-relative mt-1">
        <input
          class="dp-input-control update-input w-100"
          placeholder="Enter Serial No"
          formControlName="serialNo"
          readonly
        />
        <img
        src="../../../assets/images/delete-destructive.svg"
        class="input-cross-icon position-absolute"
        (click)="clearSerialNo()"
      />
      </div>
    </div>


    <div class="d-flex flex-column edit-gap">
      <label class="search-text">Contact no.</label>
      <input
        class="dp-input-control update-input mt-1"
        placeholder="Enter Contact No"
        formControlName="contactNo"
        minlength="10"
                    maxlength="10"
      />
      <span
                  *ngIf="
                    editDetailsForm.controls['contactNo'].invalid &&
                    editDetailsForm.controls['contactNo'].touched
                  "
                  class="error-message mt-1"
                >
                  Please enter a valid contact no
                </span>
    </div>
    <div class="d-flex flex-column edit-gap">
      <label class="search-text">Address</label>
      <textarea
        class="dp-input-control fixed-height-textarea mt-1"
        placeholder="Enter Address"
        formControlName="address"
      ></textarea>
      <span
      *ngIf="
        editDetailsForm.controls['address'].invalid &&
        editDetailsForm.controls['address'].touched
      "
      class="error-message mt-1"
    >
      Please enter a valid address
    </span>
    </div>

    <button class="dp-primary-btn save-btn edit-gap">Save Changes</button>
  </form>
</div>